var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2168 6.3588C21.4067 6.55933 21.398 6.87579 21.1975 7.06564L9.59806 18.0473C9.40524 18.2299 9.10337 18.2299 8.91055 18.0473L2.67364 12.1426C2.47311 11.9527 2.46445 11.6363 2.6543 11.4357L3.34181 10.7095C3.53166 10.509 3.84812 10.5004 4.04865 10.6902L8.91055 15.2932C9.10337 15.4757 9.40524 15.4757 9.59806 15.2932L19.8225 5.61328C20.023 5.42343 20.3395 5.43209 20.5293 5.63262L21.2168 6.3588Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.b062075c0bc9fa5161e76b2ae54dd865.svg";
export { ForwardRef as ReactComponent };